var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgChangeEmail = function SvgChangeEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16H12V14.4H8C4.528 14.4 1.6 11.472 1.6 8C1.6 4.528 4.528 1.6 8 1.6C11.472 1.6 14.4 4.528 14.4 8V9.144C14.4 9.776 13.832 10.4 13.2 10.4C12.568 10.4 12 9.776 12 9.144V8C12 5.792 10.208 4 8 4C5.792 4 4 5.792 4 8C4 10.208 5.792 12 8 12C9.104 12 10.112 11.552 10.832 10.824C11.352 11.536 12.248 12 13.2 12C14.776 12 16 10.72 16 9.144V8C16 3.584 12.416 0 8 0ZM8 10.4C6.672 10.4 5.6 9.328 5.6 8C5.6 6.672 6.672 5.6 8 5.6C9.328 5.6 10.4 6.672 10.4 8C10.4 9.328 9.328 10.4 8 10.4Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChangeEmail);
export default ForwardRef;